import { isEqual } from "lodash";
import { Component } from "react";
import { ExportFormatType } from "@app/exports/enumerations";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";

interface SelectFormatProps {
  availableExportFormats?: ExportFormatType[];
  children?: React.ReactNode;
  exportType: string; // Used for the testId
  excelDisabled: boolean;
  onOutputFormatChange: (exportFormat: ExportFormatType) => void;
  outputFormat: ExportFormatType;
}

interface SelectFormatState {
  availableOutputFormats: Array<{ key: ExportFormatType, value: string }>;
}

export default class SelectFormat extends Component<SelectFormatProps, SelectFormatState> {
  private readonly outputFormats: Array<{ key: ExportFormatType, value: string }> = [
    { key: ExportFormatType.CSV, value: "Comma-Delimited Text File (.csv)" },
    { key: ExportFormatType.Tab, value: "Tab-Delimited Text File (.txt)" },
    { key: ExportFormatType.Pipe, value: "Bar-Delimited Text File (.txt)" },
    { key: ExportFormatType.Excel, value: "Microsoft Excel Workbook (.xlsx)" },
  ];

  constructor(props: SelectFormatProps) {
    super(props);
    this.state = {
      availableOutputFormats: this.getAvailableOutputFormats(),
    }
  }

  public componentDidUpdate(prevProps: SelectFormatProps) {
    if (this.state.availableOutputFormats.length === 0 || !isEqual(prevProps.availableExportFormats, this.props.availableExportFormats)) {
      const newAvailableOutputFormats = this.getAvailableOutputFormats();
      this.setState({
        availableOutputFormats: newAvailableOutputFormats,
      })
    }

    if (this.props.excelDisabled !== prevProps.excelDisabled) {
      this.props.onOutputFormatChange(ExportFormatType.CSV)
    }
  }

  public render() {
    return (
      <>
        <p className="lead mb0 demibold">Format Filter</p>
        <div className="form-group row">
          <div className="col-lg-12">
            <QESSelect
              className="mb-0"
              containerClassName="mb-0"
              label="Please select the output format:"
              onChange={(e) => this.props.onOutputFormatChange(e.target.value as ExportFormatType)}
              testId={`export-${this.props.exportType}__format-select`}
              value={this.props.outputFormat}
            >
              {
                this.state.availableOutputFormats.map(({ key, value }) => (
                  <option key={key} value={key} disabled={key === ExportFormatType.Excel && this.props.excelDisabled}>{value}</option>
                ))}
            </QESSelect>
          </div>
        </div>
        {this.props.children}
      </>
    );
  }

  private getAvailableOutputFormats() {
    return this.props.availableExportFormats ?
      this.outputFormats.filter((format) => this.props.availableExportFormats.includes(format.key)) :
      this.outputFormats;
  }
}
